/* global localStorage */

class System {
    static definePlatform () {
        return new Promise((resolve, reject) => {
            let platformObj = {
                cordova: false,
                web: false,
                webApp: false,
                OS: null
            };

            platformObj.webApp = this.checkWebApp();
            platformObj.cordova = this.checkCordova();
            platformObj.web = this.checkWeb();

            System.platform = platformObj;

            // Define OS in cordova
            if (platformObj.cordova) {
                const cordovaOS = localStorage.getItem('cordovaOS');
                if (cordovaOS) {
                    platformObj.OS = cordovaOS;
                    resolve(platformObj);
                } else {
                    const errorTimer = setTimeout(() => {
                        let error = new Error();
                        error.name = 'Define Platform Timeout Error';
                        error.message = 'Device is never ready or the event happened before the creation of listener.';
                        reject(error);
                    }, 5000);
                    document.addEventListener('deviceready', () => {
                        clearTimeout(errorTimer);
                        platformObj.OS = window.device.platform.toUpperCase();
                        localStorage.setItem('cordovaOS', platformObj.OS);
                        resolve(platformObj);
                    });
                }
            }
            System.platform = platformObj;
            resolve(platformObj);
        });
    }

    static checkWebApp () {
        return window.matchMedia('(display-mode: standalone)').matches;
    }

    static checkCordova () {
        return window.cordova !== undefined;
    }

    static checkWeb () {
        return !this.checkWebApp() && !this.checkCordova();
    }

    // Insert a tag in HTML for async get in API
    static insertAsyncInHTML (document, tag, src, id) {
        let js;
        let fjs = document.getElementsByTagName(tag)[0];
        if (document.getElementById(id)) return;
        js = document.createElement(tag);
        js.id = id;
        js.src = src;
        js.async = true;
        js.defer = true;
        fjs.parentNode.insertBefore(js, fjs);
    }
}

export default System;



// WEBPACK FOOTER //
// ./src/utils/system.js